<div class="icon-button-container">
	<button
		mat-icon-button
		class="icon-button"
		[id]="Id"
		[attr.aria-label]="AriaLabel"
		[matMenuTriggerFor]="MatMenuTriggerFor ?? null"
		(click)="OnClick()"
	>
		<mat-icon>
			<ng-content></ng-content>
		</mat-icon>
	</button>
	<notification-badge *ngIf="BadgeCount > 0" class="badge-position" [Count]="BadgeCount"></notification-badge>
	<crownx-processing-bar *ngIf="ShowProcessingBar" class="processing-bar-position"></crownx-processing-bar>
</div>